import { CallState } from '../../../features/call/call.types';

export const getIsCallLeaving = (callState: CallState): boolean =>
  callState === CallState.LeavingAfterError ||
  callState === CallState.Leaving ||
  callState === CallState.TestCallLeaving ||
  callState === CallState.TestCallLeavingAfterError;
